export default {
  functionKey: "NOMBRE ENTIER",
  title: "NOMBRE ENTIER",
  group: "Organisation",
  origin: [],
  target: [],
  description: "Retourne le statut de vérification si une valeur est un nombre entier",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = isNaN(${origin}) ? false : (Number.isInteger(parseFloat(${origin})));`;
    return { displayCode: code, safeCode: code };
  }
}
